import { DatePicker, TimePicker } from "antd";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import { useMemo } from "react";
import "./GenericDateTime.scss";

export interface DateTimeProps {
    input: InputComponentProps<string>;
    fieldAttr?: any;
    identifier: string;
}

interface GenericDateTimeProps extends DateTimeProps {
    type: "date" | "time" | "datetime-local";
}

export const GenericDateTime = ({ identifier, input, fieldAttr, type }: GenericDateTimeProps) => {
    dayjs.extend(customParseFormat);
    dayjs.extend(advancedFormat);
    dayjs.extend(weekday);
    dayjs.extend(localeData);
    dayjs.extend(weekOfYear);
    dayjs.extend(weekYear);

    const commonProps = useMemo(
        () => ({
            id: identifier,
            ...input,
            ...fieldAttr,
            "aria-label": identifier,
            className: "input__field datePickerInput",
            dropdownClassName: "datePickerPopup",
            allowClear: false,
        }),
        [fieldAttr, identifier, input]
    );

    if (type === "time") {
        return (
            <TimePicker
                {...commonProps}
                format="HH:mm"
                value={input.value ? dayjs(input.value, ["HH:mm:ss", "HH:mm"]) : null}
            />
        );
    }

    return (
        <DatePicker
            {...commonProps}
            showTime={type === "datetime-local"}
            type={type}
            value={input.value ? dayjs(input.value) : null}
        />
    );
};
